var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("md-card-content", [
        _c(
          "div",
          { staticStyle: {} },
          [
            _c(
              "md-table",
              { staticClass: "table-hover" },
              [
                _c(
                  "md-table-row",
                  [
                    _c("md-table-head", [_vm._v("Id")]),
                    _c("md-table-head", [_vm._v("Type")]),
                    _c("md-table-head", [_vm._v("Date/Time")]),
                    _c("md-table-head", [_vm._v("Address/Suburb")]),
                    _c("md-table-head", [_vm._v("Distance")]),
                    _c("md-table-head", [_vm._v("Duration")]),
                    _vm.hasTemperature
                      ? _c("md-table-head", [_vm._v("Tempurature")])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._l(_vm.driverData, function (item, index) {
                  return _c(
                    "md-table-row",
                    {
                      key: index,
                      on: {
                        click: function ($event) {
                          return _vm.viewAddress(item)
                        },
                      },
                    },
                    [
                      _c("md-table-cell", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(index + 1) +
                            "\n                    "
                        ),
                      ]),
                      _c("md-table-cell", [
                        _c("span", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.isStopEntry ? "Stop" : "Driving") +
                              "\n                        "
                          ),
                        ]),
                      ]),
                      _c("md-table-cell", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.displayDateTime(item)) +
                            "\n                    "
                        ),
                      ]),
                      _c("md-table-cell", [
                        item.isStopEntry
                          ? _c(
                              "a",
                              {
                                staticClass: "address",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.viewAddress(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.displayAddress(item)) +
                                    "\n                        "
                                ),
                              ]
                            )
                          : _c("span", [
                              _vm._v(
                                _vm._s(item.drivingStartAddress) +
                                  " -> " +
                                  _vm._s(item.drivingEndAddress)
                              ),
                            ]),
                      ]),
                      _c("md-table-cell", [
                        item.isStopEntry
                          ? _c("span", [
                              _vm._v(
                                "\n                            -\n                        "
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.toDrivingDistanceStr(
                                      item.drivingDistanceToStop
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                      ]),
                      _c("md-table-cell", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              item.stopTimeMinutes
                                ? _vm.toTime(item.stopTimeMinutes)
                                : "-"
                            ) +
                            "\n                    "
                        ),
                      ]),
                      _vm.hasTemperature
                        ? _c(
                            "md-table-cell",
                            { attrs: { "md-label": "Avg Temperature" } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    item.isStopEntry && item.stopAvgTemperature
                                      ? item.stopAvgTemperature / 100
                                      : "-"
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _c("div", { staticClass: "label-total" }, [
              _vm.totalStops > 0
                ? _c("span", [_vm._v("Total Stops: " + _vm._s(_vm.totalStops))])
                : _vm._e(),
              _c("span", [
                _vm._v(
                  "Total Distance: " +
                    _vm._s(
                      _vm.toDistanceStr(_vm.memberData.dailyTravelDistance)
                    )
                ),
              ]),
              _c("span", [
                _vm._v(
                  "Total Time: " +
                    _vm._s(_vm.toTime(_vm.memberData.dailyTravelTimeMinutes))
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }